import { format, fromUnixTime } from "date-fns";

const FromUnixTime = (timestamp) => {
  const datetime = fromUnixTime(timestamp);

  return datetime;
};

export default FromUnixTime;
